import EventsCalendar from "./classes/events-calendar";

const eventCalendar = new EventsCalendar();

const starter = () => {
    if (document.getElementById('events-calendar-wrapper')) {
        eventCalendar.init();
    }
}

if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', () => {
        starter();
    })
} else {
    starter();
}